<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <!-- 页面头部区域 -->
        <div class='main-page-header'>
          <div>
            <el-button
              icon='el-icon-arrow-left'
              @click='handleBack'
            >返回
            </el-button>
          </div>
          <div class='journal-title'
               style='font-size: 24px;text-align: center;font-weight: bolder;cursor: pointer;'
               @click='getInfo'>
            {{ journalTitle || '-' }}
          </div>
          <div>

          </div>

          <!--          <h2 @click='reloadPage' style='cursor: pointer;color: #F2F2F2'>{{ id ? '修改' : '创建' }}刊例</h2>-->
        </div>
        <div style='width: clamp(980px, 98%, 1280px);margin: auto;' class='theme-border'>

          <!--          刊例的类型:抖音、小红书等-->
          <div style='margin: auto;padding: 20px;font-size: 14px;background-color:#f2f2f2;'
               v-if='showEditPart' class='theme-border'>
            <div class='plc-base'>
              <div><span class='form-label'> 组织：</span> <span class='form-value'>{{ formData.org_name }}</span></div>
              <div><span class='form-label'> 月份：</span> <span class='form-value'>{{ formData.date_month }}</span>
              </div>
              <div>
                <span class='form-label'> 有效期：</span>
                <span class='form-value'>{{ formData.date_range[0] }} ~ {{ formData.date_range[1] }}</span></div>
              <div>
                <span class='form-label'> 提报截止日期：</span>
                <span class='form-value'>{{ formData.deadline }}</span></div>
            </div>
            <!--            刊例列表-->
            <div v-loading='loading'
                 element-loading-text='加载中……'
                 element-loading-spinner='el-icon-loading'>
              <el-table class='dragTable' v-if='dataList &&dataList.length>0' :data='dataList'
                        :highlight-current-row='true' :stripe='true'
                        row-class-name='drag-plc-row' @row-contextmenu.prevent
                        border
                        :key='tableKey'
                        ref='dataTable'
                        style='width: 100%;opacity: 0.96'>
                <!--              <el-table-column label='刊例ID' width='100' prop='id'></el-table-column>-->
                <el-table-column label='组织' width='55' prop='org_name' align='center'></el-table-column>
                <!--              <el-table-column label='月刊ID' width='100' prop='pm_id'></el-table-column>-->
                <el-table-column align='center' label='刊例类型' min-width='200' header-align='center'>
                  <template slot-scope='{row}'>
                    <div style='display: flex;flex-direction: row;justify-content: flex-start;align-items: center'>
                      <div>
                        <el-image v-if='row.logo_url' :src='row.logo_url' :style='`width:100px;height:40px;`'
                                  :alt='row.logo_url' />
                      </div>
                      <div class='sheet_title'
                           style='margin-left: 5px;text-align: center;vertical-align: middle;font-weight: 800'>
                        <span>{{ row.sheet_title }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' min-width='240' align='center' header-align='center'
                                 label='刊例标题'>
                  <template slot-scope='{row}'>
                    <el-link v-if='row.id' type='primary' @click='jumpTo(row)'>{{ row.title || '/' }}</el-link>
                    <span v-else>{{ row.title }}</span>
                  </template>
                </el-table-column>
                <el-table-column align='center' label='有效期' min-width='180'>
                  <template slot-scope='{row}'>
                    <span>{{ row.validity_date }} ~ {{ row.expiry_date }}</span>
                  </template>
                </el-table-column>
                <el-table-column align='center' label='提报截止日期' min-width='140'>
                  <template slot-scope='{row}'>
                    <span>{{ row.deadline }}</span>
                  </template>
                </el-table-column>
                <el-table-column label='提报记录数' width='100' prop='items_count' align='center'></el-table-column>
                <el-table-column align='center' label='#' width='180' fixed='right'>
                  <template slot-scope='{row,$index}'>
                    <div class='flex-evenly'>
                      <el-link v-if="userPermissions.indexOf('plc_edit')>-1" icon='el-icon-s-grid' type='primary'
                               @click='handleTemplate(row,$index)'>
                        模板
                      </el-link>
                      <el-link v-if="userPermissions.indexOf('plc_edit')>-1" icon='el-icon-close' type='danger'
                               @click='handleRemoveRow(row,$index)'
                               :title='`${row.id}`'>
                        移除
                      </el-link>
                    </div>

                  </template>
                </el-table-column>

              </el-table>
            </div>

          </div>
          <br />
          <div class='theme-border flex-left border-effect' style='padding: 10px;gap: 10px' v-if='id'>
            <el-button @click='getInfo' type='primary' icon='el-icon-refresh' :loading='loading'>刷新</el-button>
            <template v-if="userPermissions.indexOf('plc_edit')>-1">
              <el-button @click='handleShowBaseEditView' type='primary' icon='el-icon-edit-outline'>编辑基本信息
              </el-button>
              <el-button @click='handleShowAppendDialog' type='success' icon='el-icon-plus'>追加-刊例类型</el-button>
              <el-button @click='isEdit=!isEdit' type='warning' icon='el-icon-setting'>设置封面</el-button>
            </template>
          </div>

          <div v-if='showFormView' class='theme-border' style='padding: 10px;margin-top: 10px'>
            <!--          刊例基本信息-->
            <el-form :inline='true' :model='formData' :rules='rules' ref='formData'
                     size='medium'>
              <el-form-item label='' prop='org_name'>
                <el-select
                  v-model='formData.org_name'
                  filterable
                  allow-create
                  default-first-option
                  style='width: 120px'
                  placeholder='可选可自建(最多20个字符)' clearable>
                  <el-option
                    v-for='item in options'
                    :key='item.value'
                    :label='item.label'
                    :value='item.value'>
                  </el-option>
                </el-select>

              </el-form-item>

              <el-form-item label='' prop='date_month'>
                <el-date-picker
                  :clearable='true'
                  :disabled='!!formData.id'
                  format='yyyy 年 MM 月'
                  placeholder='刊例月份'
                  style='width: 160px'
                  type='month'
                  v-model='formData.date_month'
                  value-format='yyyy-MM'>
                </el-date-picker>
              </el-form-item>
              <el-form-item label='' prop='date_range'>
                <el-date-picker
                  @change='handlerange'
                  end-placeholder='结束日期'
                  range-separator='至'
                  start-placeholder='开始日期'
                  style='width: 240px'
                  type='daterange'
                  v-model='formData.date_range' value-format='yyyy-MM-dd'>
                </el-date-picker>
              </el-form-item>
              <el-form-item label='' prop='deadline'>
                <el-date-picker
                  :clearable='true'
                  @change='handldeadline'
                  format='yyyy年MM月dd日'
                  placeholder='提报截止日期'
                  type='date'
                  v-model='formData.deadline' value-format='yyyy-MM-dd' style='width: 180px'>
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click='savePublicationMonth' type='primary' icon='el-icon-edit-outline'>保存-基本信息
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <div style='width:100%;margin-top: 10px' v-if='isEdit &&showEditPart'>
            <!--                  刊例封面配置面板-->
            <ChildPanel :base-info='formData' style='margin: auto;'></ChildPanel>
          </div>

          <div class='theme-border flex-sb default-toolbar fixed-bottom border-effect'>
            <!--            导出-->
            <PlcExport :search-condition='formData' type='warning' v-if='userPermissions.indexOf("plc_export")>-1'
                       style='display: inline-block' />

            <el-button type='danger' icon='el-icon-delete'
                       v-if="userPermissions.indexOf('plc_delete')>-1" @click='handleDelete'>删除
            </el-button>
          </div>

        </div>

      </div>
    </PageHeaderLayout>
    <!--        追加刊例平台-->
    <el-dialog title='选择刊例平台' width='880px' :visible.sync='dialogTableVisible' :modal='true' append-to-body>
      <el-table :data='gridData' border>
        <el-table-column property='name' label='刊例类型' width='120'></el-table-column>
        <el-table-column property='code' label='代号' width='120'></el-table-column>
        <el-table-column property='logo_url' label='Logo' width='80' align='center'>
          <template slot-scope='scope'>
            <el-image
              style='width: 40px; height: 40px'
              :src='scope.row.logo_url'
              fit='cover'></el-image>
          </template>
        </el-table-column>
        <el-table-column label='状态' width='100' align='center'>
          <template slot-scope='scope'>
            <span>{{ scope.row.status == 1 ? '启用' : '已停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='创建/修改时间' width='260'>
          <template slot-scope='scope'>
            <span>{{ scope.row.created_at }}/{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label='#' min-width='100' align='center'>
          <template slot-scope='scope'>
            <el-button @click='handleAppend(scope.row)' icon='el-icon-finished' round>追加</el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <!--修改：基础信息-->
    <el-dialog title='修改基本信息' width='880px' :visible.sync='dialogData.visible' :modal='true' append-to-body>
      <BaseEdit ref='refBaseEdit' @saved='dialogClose' />
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import BaseEdit from '@/pages/plc/journal/BaseEdit.vue'
import ChildPanel from '@/pages/plc/detail/ChildPanel.vue'
import PlcExport from '@/pages/plc/export/PlcExport.vue'
import { mapGetters } from 'vuex'
import { appendPublication, reSortPublication } from '@/api/plc'
import ExportBtn from '@/components/export/ExportBtn.vue'

export default {
  name: 'PlcCreateEdit',
  components: { ExportBtn, PlcExport, ChildPanel, BaseEdit, PageHeaderLayout },
  data() {
    return {
      ImgW: '40px',
      ImgH: '40px',
      showFormView: false,//显示区域
      loading: false,
      id: null,//刊例期刊ID
      formData: {
        title: '缇苏KOL刊例',
        org_name: '缇苏',
        date_month: null,
        date_range: [],
        deadline: null,
        logo_url: ''
      },
      rules: {
        // title: {required: true, message: '公司必填'},
        org_name: { required: true, message: '组织必填' },
        date_month: { required: true, message: '月份必填' },
        date_range: { required: true, message: '有效期必填' },
        deadline: { required: true, message: '截止日期必填' }
      },
      options: [
        {
          value: '缇苏',
          label: '缇苏'
        },
        {
          value: '青澜',
          label: '青澜'
        }
      ],
      dialogTableVisible: false,
      gridData: [],//刊例平台可选数据
      platforms: [],
      dataList: [],
      tableKey: 0, // 初始key
      draggingIndex: null,//拖拽的行号
      drawer: false,
      uploadFileList: [],
      editname: { title: '', index: 0 }
      , isEdit: false,
      dialogData: {
        visible: false,
        title: '刊例基础资料编辑',
        width: '1280px',
        loading: true,
        modal: false,
        hide_footer: true
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    showEditPart() {
      return !!this.id
    },
    journalTitle() {
      let title = ''
      if (this.formData.date_month && this.formData.date_month.indexOf('-') > -1) {
        const arr = this.formData.date_month.split('-')
        title = `${arr[0]}年${arr[1]}月`
      }
      if (this.formData.org_name) {
        title = `${title}${this.formData.org_name}`
      }

      return `${title}KOL刊例`
    }
  },
  methods: {
    reloadPage() {
      // 刷新当前页面
      // location.reload();

      // 强制从服务器重新加载（不使用缓存）
      location.reload(true)
    },
    handleBack() {
      this.$router.go(-1)
      // this.$confirm('确定要返回吗？未保存的内容将会丢失。', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$router.go(-1)
      // }).catch(() => {
      //   // 用户取消操作
      // })
    },
    async loadOption() {
      // this.options = []
      const { options } = await this.$api.getPublicationOption()

      const arr = [
        {
          value: '缇苏',
          label: '缇苏'
        },
        {
          value: '青澜',
          label: '青澜'
        }
      ]
      options?.org_name.map((val) => {
        if (['青澜', '缇苏'].indexOf(val) === -1)
          arr.push({ value: val, label: val })
      })

      this.options = arr
    },

    handlerange(val) {
      if (val && val.length === 2) {
        this.formData.validity_date = val[0]
        this.formData.expiry_date = val[1]
        //有效期
        if (this.dataList) {
          this.dataList.forEach((item, index) => {
            this.dataList[index].validity_date = val[0]
            this.dataList[index].expiry_date = val[1]
          })
        }
      }
    },
    handldeadline(val) {
      if (val && val.indexOf('-') > -1) {
        const arr = val.split('-')
        const date = new Date(arr[0], arr[1] - 1, arr[2])
        this.dataList.forEach((item, index) => {
          this.dataList[index].deadline = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        })
      }
    },
    //
    handleUploadSuccess(file) {
      this.formData.logo_url = file.full_path
    },
    // 图片删除回调
    handleUploadRemove() {
      this.formData.logo_url = 'https://tisu-pd.oss-cn-hangzhou.aliyuncs.com/platform_beta/20220719/T20220719142555_32702.png'
    },

    //提交基础信息
    async formSubmit(rowId) {
      const dateArr = this.formData.date_month.split('-')
      const postData = {
        org_name: this.formData.org_name,
        year: dateArr[0],
        month: dateArr[1],
        title: this.journalTitle,
        validity_date: this.formData.validity_date,
        expiry_date: this.formData.expiry_date,
        deadline: this.formData.deadline,
        id: rowId || null
      }
      const id = await this.$api.savePublicationMonthInfo(postData)
      if (id) {
        this.msgSuccess('保存成功')
        if (rowId) {
          await this.getInfo()
        } else {
          await this.$router.replace({ name: 'plc_edit', params: { id: id } })
          this.$nextTick(() => {
            this.init()
            // 执行你的操作，例如显示一个通知
            this.$notify({ type: 'success', message: '页面已更新' })
          })
        }
      }
    },
    async savePublicationMonth() {
      // 调用组件的数据验证方法

      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (!this.id)
            //创建
            this.formSubmit()
          else {
            this.formSubmit(this.id)
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该月刊例, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.delPublicationMonthInfo(this.id)
        this.$router.go(-1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async getJournalGridData() {
      // 获取最新平台信息
      const { list } = await this.$api.getJournalList({})
      this.gridData = list || []

    },
    // 显示可选刊例平台
    handleShowAppendDialog() {
      this.dialogTableVisible = true
      this.getJournalGridData()
    },
    handleAppend(item) {
      this.dialogTableVisible = false
      // this.$notify.info(`${item.name}`)
      this.handleAddRow(item)

    },
    // eslint-disable-next-line no-unused-vars
    handleEdit(item, $index) {
      this.$notify.info(`${item.title}`)
      this.dialogData.visible = true
      this.$nextTick(() => {
        if (this.$refs['refBaseEdit'])
          this.$refs['refBaseEdit'].show(item.id)
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.loading = false
      this.dialogData.visible = false
      setTimeout(() => {
        this.getInfo()
      }, 500)

    },
    async handleRemoveRow(item, $index) {
      this.$notify.info(`${item.title}`)

      if (item.id) {
        // this.$notify.info(`发起移除请求`)
        await this.$api.deletePublicationInfo(item.id)
        this.dataList.splice($index, 1)
      }
    },
    // 修复布局
    // fixTableLayout() {
    //   // 确保在DOM更新后执行
    //   this.$nextTick(() => {
    //     const table = this.$refs.dataTable
    //     if (table && table.doLayout) {
    //       table.doLayout() // 重新计算布局
    //     }
    //   })
    // },
    async handleAddRow(row) {

      const item = {
        id: null,
        pm_id: this.id,
        org_name: this.formData.org_name,
        platform_code: row.code,
        platform_name: row.name,
        sheet_title: `${row.name}KOL`,
        logo_url: row.logo_url,
        title: `${this.formData.year || '-'}年${this.formData.month || '-'}月${this.formData.org_name || ''}${row.name}KOL刊例`,
        validity_date: this.formData.validity_date,
        expiry_date: this.formData.expiry_date,
        deadline: this.formData.deadline,
        order: this.dataList.length,
        items_count: 0
      }
      const index = this.dataList.findIndex(value => value.platform_code === item.platform_code)
      if (index === -1) {
        const pIndex = this.dataList.push(item)
        // 发起请求
        const params = {
          pm_id: this.id,
          org_name: this.formData.org_name,
          year: this.formData.year,
          month: this.formData.month,
          title: item.title,
          platform_code: item.platform_code,
          sheet_title: `${item.sheet_title}`,
          validity_date: item.validity_date,
          expiry_date: item.expiry_date,
          deadline: item.deadline,
          logo_url: item.logo_url,
          order: this.dataList.length,
          adopt_options: ['same_notice', 'same_tpl', 'same_record']
        }

        const { info } = await appendPublication(params)
        if (info && info.id) {
          //更新
          this.dataList[pIndex - 1] = { ...info }
          this.tableKey += 1
        }
      } else {
        this.$notify.warning(`无效操作（重复追加平台：${item.platform_name}）`)
      }


    },
    jumpTo(row) {
      this.$router.push({ name: 'plc_detail_item', params: { id: row.id } })
    },
    handleTemplate(row) {
      // this.$notify.info(`配置模板:${row.platform_name}-${row.platform_code}`)
      if (row.id)
        this.$router.push({ name: 'plc_tpl', params: { id: row.id } })
      else
        this.$notify.warning('无法配置模板')
    },
    handleShowCover() {
      this.isEdit = true
    },
    handleShowBaseEditView() {
      this.showFormView = !this.showFormView
    },
    async getInfo() {
      // console.log('========== getInfo ==========')
      this.loading = true
      const { info, list } = await this.$api.getPublicationMonthDetail(this.id)
      // //刊例月份
      info.date_month = `${info.year}-${info.month}`
      // //有效期
      info.date_range = [info.validity_date, info.expiry_date]
      this.formData = info || {}
      this.dataList = list || []
      this.$nextTick(() => {
        this.addDragEvents()
        setTimeout(() => {
          this.loading = false
        }, 200)
      })

    },
    // ============================ <<start 表格行拖拽 事件绑定和处理=============================
    // 添加拖拽事件
    addDragEvents() {
      // 获取所有带有类名 'drag-row' 的表格行
      const rows = document.querySelectorAll('.drag-plc-row')
      // 遍历每一行，添加拖拽事件
      if (rows && rows.length > 0) {
        rows.forEach((row, index) => {
          try {
            row.draggable = true // 设置行元素为可拖拽
            // 开始拖拽时的事件处理
            // console.log('r', index, row)
            row.ondragstart = (event) => this.handleDragStart(event, index)
            // 拖拽经过时的事件处理
            row.ondragover = (event) => this.handleDragOver(event)
            // 拖拽放下时的事件处理
            row.ondrop = (event) => this.handleDrop(event, index)
          } catch (e) {
            // console.log('addDragEvents', e)
          }

        })
      }

    },
    // 处理拖拽开始事件
    handleDragStart(event, index) {
      this.draggingIndex = index // 记录当前拖拽行的索引
      event.dataTransfer.effectAllowed = 'move' // 设置拖拽效果为移动
      event.dataTransfer.setData('text/plain', index) // 将索引存储到拖拽数据中
    },
    // 处理拖拽经过事件
    handleDragOver(event) {
      event.preventDefault() // 阻止默认事件，允许放置
      event.dataTransfer.dropEffect = 'move' // 设置拖拽效果为移动
    },
    // 处理拖拽放下事件
    handleDrop(event, targetIndex) {
      const sourceIndex = this.draggingIndex // 获取开始拖拽时记录的索引

      // 如果源索引和目标索引相同，直接返回
      if (sourceIndex === targetIndex) return

      // 创建项目列表的副本
      const projects = [...this.dataList]
      // 删除源位置的项目，并存储被拖拽的项目
      const [movedItem] = projects.splice(sourceIndex, 1)
      // 在目标位置插入被拖拽的项目
      projects.splice(targetIndex, 0, movedItem)

      // 更新项目列表数据
      this.dataList = projects
      this.draggingIndex = null // 重置拖拽索引

      this.handleReSort()

    },
    handleReSort() {
      //上报调整后的排序规则
      const ids = this.dataList.map((row) => {
        return row.id
      })

      reSortPublication(ids)
      // console.log('ids', ids)
    },
    // ============================ 表格行拖拽  end>> =============================

    init() {
      // let t = this
      // await this.getPlatforms()
      const id = this.$route.params && this.$route.params.id
      if (id) {
        this.id = id
        this.showFormView = false
        this.isEdit = true
        this.getInfo()
        //显示封面
        this.handleShowCover()

      } else {
        // await this.getPlatforms()
        const date = new Date()
        date.setMonth(date.getMonth() + 1)//默认下个月的月份
        this.formData.date_month = date.getFullYear() + '-' + (date.getMonth() + 1)
        //
        this.isEdit = false
        this.showFormView = true

        this.loadOption()
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
  },
  updated() {
    // 数据更新后重新添加拖拽事件
    // 使用 this.$nextTick 获取表格行的 DOM 元素
    this.$nextTick(() => {
      this.addDragEvents()
    })
  }

  // // 1. 创建前
  // beforeCreate() {
  //   console.log('beforeCreate：无法访问 data/methods')
  // },
  // // 2. 创建完成
  // created() {
  //   this.init()
  //   console.log('created：可以访问 data/methods，可发请求')
  // },
  // // 3. 挂载前
  // beforeMount() {
  //   console.log('beforeMount：模板编译完成，未渲染真实DOM')
  // },
  // // 4. 挂载完成（核心）
  // mounted() {
  //   console.log('mounted：DOM渲染完成，可操作DOM')
  //   this.timer = setInterval(() => {
  //   }) // 模拟定时器
  // },
  // // 5. 更新前
  // beforeUpdate() {
  //   console.log('beforeUpdate：数据更新，页面未更新')
  // },
  // // 6. 更新完成
  // updated() {
  //   console.log('updated：页面已完成更新')
  // },
  // // 7. 销毁前（核心清理）
  // beforeDestroy() {
  //   console.log('beforeDestroy：组件即将销毁，清理定时器/事件')
  //   clearInterval(this.timer) // 清理定时器
  // },
  // // 8. 销毁完成
  // destroyed() {
  //   console.log('destroyed：组件已完全销毁')
  // }
}
</script>
<style scoped>
/* 页面同步-返回栏 */
.main-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  line-height: 50px;
  height: 50px;
}


.fixed-bottom {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 50px;
  width: clamp(980px, 90%, 1280px);
  z-index: 999;
  background-color: rgba(12, 12, 12, 0.8);
  opacity: 0.8;
}

.fixed-bottom:hover {
  opacity: 0.9;
}

.plc-base {
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 10px;
  border: #F2F2F2 1px solid;
}

.plc-base .form-label {
  font-weight: bolder;
  font-size: 14px;
}
</style>
